import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { assignOperatorsStart } from '../../../../redux/websites/websites.actions';
import useTranslation from 'hooks/useTranslation';

const ModalAssignOperatorsAction = ({
  toggle,
  selectedOperatorIds,
  websiteId,
}) => {
  const dispatch = useDispatch();
  const { getTranslation } = useTranslation("WEBSITES");
  const { t } = getTranslation();

  const handleOperatorsAssignment = (event) => {
    if (event) event.preventDefault();
    dispatch(assignOperatorsStart({ selectedOperatorIds, websiteId, toggle }));
  };

  return (
    <>
      <div className='modal__container__footer__right'>
        <a
          href='#/'
          onClick={toggle}
          className='btn btn-tertiary'
          id='closeModal'
        >
          {t("MODAL").CANCEL}
        </a>
        <a
          href='#/'
          className='btn btn-primary'
          id='saveClose'
          onClick={handleOperatorsAssignment}
        >
          {t("MODAL").SAVE}
        </a>
      </div>
      <div className='modal__container__footer__left'></div>
    </>
  );
};

ModalAssignOperatorsAction.propTypes = {
  toggle: PropTypes.func.isRequired,
  selectedOperatorIds: PropTypes.arrayOf(PropTypes.string.isRequired),
};

export default ModalAssignOperatorsAction;
